// src/utils/districts.js

export class District {
  constructor({ name, region, flag }) {
    this.name = name;
    this.region = region;
    this.flag = flag;
  }

  toJSON() {
    return {
      name: this.name,
      region: this.region,
      flag: this.flag,
    };
  }

  get displayName() {
    return `${this.flag} ${this.name}`;
  }

  get displayWithRegion() {
    return `${this.flag} ${this.name} (${this.region})`;
  }

  matchesSearch(searchTerm) {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase().trim();
    return (
      this.name.toLowerCase().includes(term) ||
      this.region.toLowerCase().includes(term)
    );
  }
}

export const districts = [
  new District({ name: 'Kampala', region: 'Central', flag: '🏙️' }),
  new District({ name: 'Wakiso', region: 'Central', flag: '🌿' }),
  new District({ name: 'Mukono', region: 'Central', flag: '🌄' }),
];

export const sortedDistricts = [...districts].sort((a, b) => 
  a.name.localeCompare(b.name)
);

export const getDistrictByName = (name) => {
  if (!name) return null;
  return districts.find(district => 
    district.name.toLowerCase() === name.toLowerCase()
  ) || null;
};

export const searchDistricts = (searchTerm) => {
  if (!searchTerm) return sortedDistricts;
  const term = searchTerm.toLowerCase().trim();
  return sortedDistricts.filter(district => district.matchesSearch(term));
};

export const getDistrictsByRegion = (region) => {
  if (!region) return sortedDistricts;
  return sortedDistricts.filter(
    district => district.region.toLowerCase() === region.toLowerCase()
  );
};

export const getRegions = () => {
  const regionSet = new Set(districts.map(d => d.region));
  return Array.from(regionSet).sort();
};

export const getDistrictsByRegionGrouped = () => {
  const grouped = {};
  districts.forEach(district => {
    if (!grouped[district.region]) {
      grouped[district.region] = [];
    }
    grouped[district.region].push(district);
  });
  return grouped;
};

export default {
  districts,
  sortedDistricts,
  District,
  getDistrictByName,
  searchDistricts,
  getDistrictsByRegion,
  getRegions,
  getDistrictsByRegionGrouped,
};